import create from 'zustand';

export interface RouteState {
  routeLabels: string[];
  addRoute: (route: string) => void;
  clearRoutes: () => void;
  removeRoute: (route: string) => void;
}

export const useRouteStore = create<RouteState>((set) => ({
  routeLabels: [],
  addRoute: (route: string) =>
    set((state: RouteState) => {
      return { routeLabels: [...state.routeLabels, route] };
    }),
  clearRoutes: () => set({ routeLabels: [] }),
  removeRoute: (route: string) =>
    set((state: RouteState) => {
      return { routeLabels: state.routeLabels.filter((r) => r !== route) };
    }),
}));
